import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { RedTextButton } from 'components/buttons/RedTextButton';
import { Text1, Text1Bold } from 'components/typography/Texts';

import { OrganizationFormData } from './add-organization/useAddOrganizationForm';

const DetailsWrapper = styled(Text1Bold)`
  white-space: pre-wrap;
`;

const EINWrapper = styled(Text1)`
  margin-top: 12px;
`;

const Button = styled(RedTextButton)`
  width: 100%;
  height: 30px;
`;

interface Props {
  organization: OrganizationFormData;
  onChangePress: () => void;
}

const OrganizationSummary = ({ organization, onChangePress }: Props) => {
  const { t } = useTranslation('myProfile');

  const { name, addressLine1, addressLine2, city, state, zipCode, ein } = organization;
  const detailsInfo = `${name}\n${addressLine1} ${addressLine2 || ''}\n${city}, ${state} ${zipCode}`;
  const einInfo = `${t('form-inputs.ein-placeholder')}: ${ein}`;

  return (
    <>
      <DetailsWrapper>{detailsInfo}</DetailsWrapper>
      <EINWrapper>{einInfo}</EINWrapper>
      <Button onClick={onChangePress}>{t('become-fundraiser.verify-organization.change-organization')}</Button>
    </>
  );
};

export default OrganizationSummary;
